export default {
  NONE: 'none',
  URL: 'url',
  RESERVATIONS: 'reservations',
  ONLINE_ORDERING: 'online_ordering'
};
